import {useState, useRef} from "react";
import axios from "axios";
import {useEffect} from "react";
import barcodeHelp from "./barcodeHelp.png";
import {toast} from "react-toastify";
import _axios from "../../httpService";
import MoneyTax from "./MoneyTax";

export default function AdvanceSetting({isLog}) {

  const [formDataPage, setFormDataPage] = useState({
    barcode: {
      barcodeCount: "",
      barcodeLength: "",
      barcodeWidth: "",
      paperWidth: "",
      productFont: "",
      priceFont: "",
      productCode: false,
      productPrice: false,
      productColor: false,
      productSize: false,
      productGroupCode: false,
    }, currency: {STR1: ""}, advancePermission: false, tax: "",
    print: {text4: "", text5: "", text6: ""}, trigger: {trigger: false}, sellFactorPrintSize: "a4",
  })
  const [isActivePage, setIsActivePage] = useState(false)

  useEffect(() => {
    axios.get(`${localStorage.getItem("apiUrl")}/settings/`, {
      params: {settingName: "advanced"}, headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then(({data}) => {
      if (data.barcode.barcodeCount === "0" || data.barcode.barcodeCount === 0 || data.barcode.barcodeCount === undefined) {
        data.barcode.barcodeCount = "1"
      }
      setFormDataPage(data)
      setIsActivePage(data?.active)
    });

  }, []);
  const formRef = useRef(null)

  function submitAdvanceSetting(e) {
    e.preventDefault();
    let form = e.target;

    console.log(form.elements);

    _axios.post(`${localStorage.getItem("apiUrl")}/settings/?settingName=advanced`, formDataPage).then(res => {

      toast.success("اطلاعات ثبت شد.")

    })
  }

  function formChangeHandlerSection(section, key = null, value = 0) {
    const temp = {...formDataPage}
    if (key === null) {
      temp[section] = value;
    } else {
      temp[section][key] = value;
    }
    setFormDataPage(temp)
  }

  return (
    <>
      {isActivePage ?
        <form ref={formRef} onSubmit={submitAdvanceSetting} className="advanceSet">
          <h5>
            <i className="fa fa-print ms-1"></i> پاورقی های چاپ
          </h5>
          <div className="row">
            <div className="col-md-8 mx-auto">
              <div className="form-group">
                <label>متن پایین چاپ فهرست ها</label>
                <textarea
                  // ref={textUnderIndexRef}
                  name="text4"
                  className="form-control"
                  rows={1}
                  value={formDataPage.print.text4}
                  onChange={(event) => formChangeHandlerSection("print", "text4", event.target.value)}

                />
              </div>
              <div className="form-group">
                <label>متن پایین فاکتورها</label>
                <textarea
                  // ref={textUnderBillsRef}
                  name="text5"
                  className="form-control"
                  rows={1}
                  value={formDataPage.print.text5}
                  onChange={(event) => formChangeHandlerSection("print", "text5", event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>متن زیر صورتحساب مشتری</label>
                <textarea
                  // ref={textUnderCustomerBillRef}
                  name="text6"
                  className="form-control"
                  rows={1}
                  value={formDataPage.print.text6}
                  onChange={(event) => formChangeHandlerSection("print", "text6", event.target.value)}

                />
              </div>
            </div>
          </div>

          <h5>
            <i className="fa fa-barcode ms-1"></i>تنظیمات بارکد
          </h5>
          <div className="row mb-4">
            <div className="col-md-4 ">
              <div className="form-group">
                <label>تعداد بارکد </label>
                <select
                  onChange={(event) => formChangeHandlerSection("barcode", "barcodeCount", event.target.value)}
                  value={formDataPage.barcode.barcodeCount}
                  // ref={barcodeCountRef}
                  className="form-control" name="barcodeCount">
                  <option value={'1'}>1</option>
                  <option value={'2'}>2</option>
                  <option value={'3'}>3</option>
                </select>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-4 mx-auto">
              <div className="form-group">
                <label>طول بارکد (mm)</label>
                <input
                  // ref={barcodeWidthRef}
                  type="text"
                  name="barcodeWidth"
                  // /*  طول و عرض درست شد اینجا  نام رو توی کامیت قبلی عوض کردم*/
                  value={formDataPage.barcode.barcodeWidth}
                  onChange={(event) => formChangeHandlerSection("barcode", "barcodeWidth", event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4 mx-auto">
              <div className="form-group">
                <label>عرض بارکد (mm)</label>
                <input
                  // ref={barcodeLengthRef}
                  type="text" name="barcodeLength"

                  value={formDataPage.barcode.barcodeLength}
                  onChange={(event) => formChangeHandlerSection("barcode", "barcodeLength", event.target.value)}

                />
              </div>
            </div>

            <div className="col-md-4 mx-auto">
              <div className="form-group">
                <label>طول کاغذ (mm)</label>
                <input
                  // ref={paperWidthRef}
                  type="text" name="paperWidth"
                  value={formDataPage.barcode.paperWidth}
                  onChange={(event) => formChangeHandlerSection("barcode", "paperWidth", event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4 mx-auto">
              <div className="form-group">
                <label>اندازه فونت نام کالا(px)</label>
                <input
                  // ref={productFontRef}
                  type="text" name="productFont"
                  value={formDataPage.barcode.productFont}
                  onChange={(event) => formChangeHandlerSection("barcode", "productFont", event.target.value)}

                />
              </div>
            </div>
            <div className="col-md-4 mx-auto">
              <div className="form-group">
                <label>اندازه فونت قیمت(px)</label>
                <input
                  // ref={priceFontRef}
                  type="text" name="priceFont"
                  value={formDataPage.barcode.priceFont}
                  onChange={(event) => formChangeHandlerSection("barcode", "priceFont", event.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4 mx-auto">

            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-4 mx-auto">
              <img src={barcodeHelp} alt={"راهنما"}/>
            </div>
          </div>
          <h6 className="mb-4">سایز پرینت فاکتور فروش</h6>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <div className="form-check">
                  <select
                    value={formDataPage.sellFactorPrintSize}
                    onChange={e => {
                      const sellFactorPrintSize = e.target.value
                      setFormDataPage({...formDataPage, sellFactorPrintSize})
                    }}
                    style={{width: 'fit-content'}}
                    className={"p-2 form-control"}>
                    <option value="" hidden={true}>انتخاب کنید</option>
                    <option value="8cm"> پرینت 8 سانتیمتری</option>
                    <option value="A5"> چاپ روی کاغذ A5</option>
                    <option value="A4"> چاپ روی کاغذ A4</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
          <h6 className="mb-4">چه مشخصاتی در بارکد چاپ شود</h6>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <div className="form-check">
                  <input
                    // ref={productCodeRef}
                    id={"productCode"} type="checkbox" className="form-check-input"
                    name="productCode"
                    checked={formDataPage.barcode.productCode}
                    onChange={(event) => formChangeHandlerSection("barcode", "productCode", event.target.checked)}

                  />
                  <label htmlFor={"productCode"} className="form-check-label mr-3">کد کالا</label>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <div className="form-check">
                  <input
                    // ref={priceCheckBoxRef}
                    id={"priceCheckBox"} type="checkbox" className="form-check-input"
                    name="productPrice"

                    checked={formDataPage.barcode.productPrice}
                    onChange={(event) => formChangeHandlerSection("barcode", "productPrice", event.target.checked)}

                  />
                  <label htmlFor={"priceCheckBox"} className="form-check-label mr-3">قیمت</label>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <div className="form-check">
                  <input
                    // ref={colorCheckBoxRef}
                    id={"colorCheckBoxRef"} type="checkbox" className="form-check-input"
                    name="productColor"

                    checked={formDataPage.barcode.productColor}
                    onChange={(event) => formChangeHandlerSection("barcode", "productColor", event.target.checked)}

                  />
                  <label htmlFor={"colorCheckBoxRef"} className="form-check-label mr-3">رنگ</label>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <div className="form-check">
                  <input
                    // ref={sizeCheckBoxRef}
                    id={"sizeCheckBox"} type="checkbox" className="form-check-input"
                    name="productSize"
                    checked={formDataPage.barcode.productSize}
                    onChange={(event) => formChangeHandlerSection("barcode", "productSize", event.target.checked)}

                  />
                  <label htmlFor={"sizeCheckBox"} className="form-check-label mr-3">سایز</label>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <div className="form-check">
                  <input
                    // ref={productGroupCode}
                    id={"productGroupCode"} type="checkbox" className="form-check-input"
                    name="productGroupCode"
                    checked={formDataPage.barcode.productGroupCode}
                    onChange={(event) => formChangeHandlerSection("barcode", "productGroupCode", event.target.checked)}

                  />
                  <label htmlFor={"productGroupCode"} className="form-check-label mr-3">کد گروه کالا</label>
                </div>
              </div>
            </div>
          </div>


          <MoneyTax formDataPage={formDataPage} formChangeHandlerSection={formChangeHandlerSection}/>

          {/*<h5><i className="far fa-shopping-bag"></i> همگام سازی با فروشگاه</h5>*/}
          <div className={'d-flex flex-wrap justify-content-start mt-5'}>
            <div className="form-check">
              <input
                // ref={triggerToShopRef}
                name="trigger" type="checkbox" className="form-check-input" id="tigger"
                checked={formDataPage.trigger.trigger}
                onChange={(event) => formChangeHandlerSection("trigger", "trigger", event.target.checked)}
              />
              <label className=" form-check-label" htmlFor="tigger">&nbsp;همگام سازی با اطلاعات فروشگاه </label>
            </div>
            <div className="form-check">
              <input
                // ref={triggerToShopRef}
                name="trigger" type="checkbox" className="form-check-input"
                id="advanceSystem"
                checked={formDataPage.advancedPermissions}
                onChange={(event) => formChangeHandlerSection("advancedPermissions", null, event.target.checked)}
              />
              <label className=" form-check-label" htmlFor="advanceSystem">&nbsp;سیستم دسترسی پیشرفته </label>
            </div>
          </div>

          <div className="text-center">
            <input
              type="submit"
              value="ثبت"
              id="backsubmit"
              className="mt-5 btnCustom btnSubmit"
            />
          </div>
        </form> : <></>}
    </>
  )
}
